export default (fieldName, choices = [], initial = '') => ({
    open: false,
    choices: choices,
    value: '',
    shouldValidate: false,
    fieldName: fieldName,
    get filteredChoices() {
        if (this.value === '' || this.currentChoice !== undefined) {
            return this.choices;
        } else {
            return this.choices.filter(item => item.label.toLowerCase().includes(this.value.toLowerCase()));
        }
    },
    get currentChoice() {
        return this.choices.find(item => item.label.toLowerCase() === this.value.toLowerCase());
    },
    get currentChoiceId() {
        if(!this.currentChoice) {
            return ''
        }
        return this.currentChoice.id
    },
    get currentFlag() {
        return (!this.currentChoice) ? 'xx' : this.currentChoice.isoCode2.toLowerCase();
    },
    isValidResponse: function() {
        if(this.errors === undefined){
            throw new Error('You should initialize the form data first');
        }
        const isValid = !!this.currentChoice
        this.setError(this.fieldName, isValid ? [] : ['invalid'])
        if(this.shouldValidate){
            return isValid;
        }
        return true;
    },
    flag: (choice) => {
        return (!choice || !choice.isoCode2) ? 'xx' : choice.isoCode2.toLowerCase();
    },
    setValueById: function (id) {
        const initialChoice = this.choices.find(choice => choice.id === id);
        if(!!initialChoice){
            this.value = initialChoice.label;
        } else {
            this.value = '';
        }
    }
})